export function isZeroNumber(value) {
    if (typeof value !== 'number' && typeof value !== 'string')
        return false;
    const raw = String(value).replace(/\s+/g, '').replace(/,/g, '.');
    return raw !== '' && Number(raw) === 0;
}
